import React from "react";
import { FaArrowTrendUp, FaChartLine, FaLightbulb } from "react-icons/fa6";
import banner1 from "../assets/banner1.jpg";

export default function LinesSubstations() {
  const features = [
    {
      icon: <FaChartLine size={20} className="text-primary" />,
      text: "ICT strategy development aligned with organizational goals, budgets, and long-term digital priorities.",
    },
    {
      icon: <FaLightbulb size={20} className="text-primary" />,
      text: "Technology assessments that clarify where improvements, modernization, or simplification will create the most value.",
    },
    {
      icon: <FaArrowTrendUp size={20} className="text-primary" />,
      text: "Actionable roadmaps that help leaders move from isolated fixes to structured transformation planning.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">ICT Consulting & Strategy</h2>
          <p className="section-copy">
            Nova Technologies helps organizations make confident technology decisions by
            connecting business priorities with practical digital strategy.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner1} alt="ICT Consulting and Strategy" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Consulting and strategy engagements are designed to give leadership teams
            clarity on where technology should support efficiency, service quality, and
            future growth. The focus is on practical direction, not complexity for its own
            sake.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Review current systems, workflows, and operational pain points.</li>
            <li>Identify opportunities for improvement, integration, and modernization.</li>
            <li>Define a phased roadmap with clear priorities and expected value.</li>
            <li>Support decision-making as implementation planning moves forward.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
